import type { Channel } from "@expert/shared-types";

import type { AgentActivity } from "@/sdk";

const MESSAGING_AUX_ACTIVITY_NAME = "messaging";

/**
 * Chat-only carve-out: treats the Amazon Connect "messaging" aux status as not selectable.
 *
 * FIXME: remove this and all its callers once the "messaging" aux is retired from Connect.
 * It was added by voice for pre-chat handoff; in chat it just blocks routing, yet chat agents
 * pick it expecting it to enable chat work. Voice still relies on it, so this is gated to chat.
 */
export default function isMessagingAuxBlockedInChat(channel: Channel, activity: AgentActivity): boolean {
    return channel === "chat" && activity.trim().toLowerCase() === MESSAGING_AUX_ACTIVITY_NAME;
}
